import Paywall from "components/Paywall/Paywall";
import SegmentControl from "components/SegmentControl/SegmentControl";
import { useSession } from "contexts";
import { useState } from "react";
import { OrgSubtypes } from "utils/orgTypes";
import FlightReports from "./Partials/FlightReports";
import FuelOilReports from "./Partials/FuelOilReports";
import { ChartBarIcon } from "@heroicons/react/24/solid";
import Header from "components/Header/Header";
import Tabs from "components/Tabs/Tabs";

const Reports = function() {
  const { organizationSubtype } = useSession();
  const [selectedTab, setSelectedTab] = useState('Flights');
  return(
    <>
      {organizationSubtype === OrgSubtypes.FREE ? <Paywall /> : 
        <div className="flex flex-col">
          {/* Header */}
          <Header title="Reports" icon={ChartBarIcon} className="">
            <select onChange={(e)=>{setSelectedTab(e.target.value)}} className="rounded border border-slate-300 bg-slate-50 h-12 md:h-10 w-44 px-2 text-brand focus:shadow-inner placeholder:text-slate-400 placeholder:text-sm pr-8 text-ellipsis">
              <option selected value="Flights">Flight Reports</option>
              <option value="Fuel & Oil">Fuel & Oil Reports</option>
            </select>
          </Header>
          {/* Dashboard */}
          { selectedTab === 'Flights' && <FlightReports /> }
          { selectedTab === 'Fuel & Oil' && <FuelOilReports /> }
        </div>
      }
    </>
  );
}

export default Reports;